<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        For each of the numbers listed below, determine the number of significant figures.
      </p>

      <p class="mb-0">
        <stemble-latex :content="'a) ' + number1" />
      </p>

      <v-radio-group v-model="inputs.input1" row :disabled="!allowEditing" class="mt-1 pl-6">
        <v-radio
          v-for="option in options1"
          :key="option.value"
          class="d-inline-block pr-1"
          :value="option.value"
        >
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>

      <p class="mb-0">
        <stemble-latex :content="'b) ' + number2" />
      </p>

      <v-radio-group v-model="inputs.input2" row :disabled="!allowEditing" class="mt-1 pl-6">
        <v-radio
          v-for="option in options1"
          :key="option.value"
          class="d-inline-block pr-1"
          :value="option.value"
        >
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>

      <p class="mb-0">
        <stemble-latex :content="'c) ' + number3" />
      </p>

      <v-radio-group v-model="inputs.input3" row :disabled="!allowEditing" class="mt-1 pl-6">
        <v-radio
          v-for="option in options1"
          :key="option.value"
          class="d-inline-block pr-1"
          :value="option.value"
        >
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>

      <p class="mb-0">
        <stemble-latex :content="'d) ' + number4" />
      </p>

      <v-radio-group v-model="inputs.input4" row :disabled="!allowEditing" class="mt-1 pl-6">
        <v-radio
          v-for="option in options1"
          :key="option.value"
          class="d-inline-block pr-1"
          :value="option.value"
        >
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>

      <p class="mb-0">
        <stemble-latex :content="'e) ' + number5" />
      </p>

      <v-radio-group v-model="inputs.input5" row :disabled="!allowEditing" class="mt-1 pl-6">
        <v-radio
          v-for="option in options1"
          :key="option.value"
          class="d-inline-block pr-1"
          :value="option.value"
        >
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import LatexNumber from '../displayers/LatexNumber';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'SigFigs1',
  components: {
    LatexNumber,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      // Put a list of inputs or computed properties here to be sent for marking
      inputs: {
        input1: null,
        input2: null,
        input3: null,
        input4: null,
        input5: null,
      },
      options1: [
        {text: '1', value: '1'},
        {text: '2', value: '2'},
        {text: '3', value: '3'},
        {text: '4', value: '4'},
        {text: '5', value: '5'},
        {text: '6', value: '6'},
        {text: '7', value: '7'},
        {text: '8', value: '8'},
        {text: '9', value: '9'},
        {text: '10', value: '10'},
      ],
    };
  },
  computed: {
    number1Integer() {
      return this.taskState.getValueBySymbol('arrayVariable1').content;
    },
    number2Integer() {
      return this.taskState.getValueBySymbol('arrayVariable2').content;
    },
    number3Integer() {
      return this.taskState.getValueBySymbol('arrayVariable3').content;
    },
    number4Integer() {
      return this.taskState.getValueBySymbol('arrayVariable4').content;
    },
    number5Integer() {
      return this.taskState.getValueBySymbol('arrayVariable5').content;
    },
    number1() {
      if (this.number1Integer.value === 1) {
        return '$368$';
      } else if (this.number1Integer.value === 2) {
        return '$566$';
      } else if (this.number1Integer.value === 3) {
        return '$894$';
      } else if (this.number1Integer.value === 4) {
        return '$97$';
      } else if (this.number1Integer.value === 5) {
        return '$8156$';
      } else {
        return '$241$';
      }
    },
    number2() {
      if (this.number2Integer.value === 1) {
        return '$1943$';
      } else if (this.number2Integer.value === 2) {
        return '$8217$';
      } else if (this.number2Integer.value === 3) {
        return '$124$';
      } else if (this.number2Integer.value === 4) {
        return '$87$';
      } else if (this.number2Integer.value === 5) {
        return '$36$';
      } else {
        return '$729$';
      }
    },
    number3() {
      if (this.number3Integer.value === 1) {
        return '$8420$';
      } else if (this.number3Integer.value === 2) {
        return '$7130$';
      } else if (this.number3Integer.value === 3) {
        return '$610$';
      } else if (this.number3Integer.value === 4) {
        return '$4800$';
      } else if (this.number3Integer.value === 5) {
        return '$190$';
      } else {
        return '$53000$';
      }
    },
    number4() {
      if (this.number4Integer.value === 1) {
        return '$308$';
      } else if (this.number4Integer.value === 2) {
        return '$7056$';
      } else if (this.number4Integer.value === 3) {
        return '$1204$';
      } else if (this.number4Integer.value === 4) {
        return '$90731$';
      } else if (this.number4Integer.value === 5) {
        return '$20402$';
      } else {
        return '$3408$';
      }
    },
    number5() {
      if (this.number5Integer.value === 1) {
        return '$2010$';
      } else if (this.number5Integer.value === 2) {
        return '$34050$';
      } else if (this.number5Integer.value === 3) {
        return '$30480$';
      } else if (this.number5Integer.value === 4) {
        return '$490560$';
      } else if (this.number5Integer.value === 5) {
        return '$28050$';
      } else {
        return '$4090$';
      }
    },
  },
};
</script>
